import React from "react";
import CardLayout from "../common/CardLayout";
import PureReactTable from "../../component-js/common/PureReactTable";
import { useIntl } from "react-intl";

const style = {
  gridCustom: { height: 350 },
};

const createColumns = [
  { Header: "Created date", accessor: "created", width: 300 },
  { Header: "Edit user", accessor: "editor_full_name", width: 300 },
  { Header: "Status", accessor: "status_label", width: 265 },
];

const editColumns = [
  { Header: "Edit date", accessor: "edited", width: 400 },
  { Header: "Edit user", accessor: "name", width: 465 },
];

const editColumnsAction = [
  { Header: "Action", accessor: "action", width: 200 },
  { Header: "Edit date", accessor: "edited", width: 300 },
  { Header: "Edit user", accessor: "name", width: 365 },
];

// Define specific type for log entries based on your actual data structure
interface LogEntry {
  id: number | string;
  timestamp: Date | string;
  action: string;
  user?: string;
  details?: string;
  severity?: "info" | "warning" | "error";
  // Add other log entry properties as needed
}

interface CardANSLogProps {
  titleCard?: string;
  hideCallback?: () => void;
  closeable?: boolean;
  toggleable?: boolean;
  createDetail?: boolean;
  editDetail?: boolean;
  dataList?: LogEntry[];
}

const DEFAULT_PROPS = {
  titleCard: "Document Log",
  hideCallback: () => { },

  closeable: true,
  toggleable: true,
  createDetail: false,
  editDetail: false,

  dataList: [],
};

const CardANSLog = (propsParam: CardANSLogProps) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined)),
  };

  return (
    <CardLayout
      titleText={props.titleCard}
      headerColor="blue"
      closeable={props.closeable}
      toggleable={props.toggleable}
      onClose={props.hideCallback}
    >
      {props.createDetail && (
        <PureReactTable
          data={props.dataList}
          style={style.gridCustom}
          columns={createColumns}
          showPagination={false}
          pageSize={10}
          manual
        />
      )}

      {props.editDetail && (
        <PureReactTable
          data={props.dataList}
          style={style.gridCustom}
          columns={props.showAction ? editColumnsAction : editColumns}
          showPagination={false}
          pageSize={10}
          manual
        />
      )}
    </CardLayout>
  );
};

CardANSLog.displayName = "CardANSLog";

export default React.memo(CardANSLog);
